module.exports = __webpack_public_path__ + "img/orderNull.3c40fa95.png";